import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface TimeSheetSliceState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allTimeSheet: [] | null | any;
  allMentors: [] | null | any;
  filteredData: [] | null | any;
}
const initialState: TimeSheetSliceState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allTimeSheet: null,
  allMentors: null,
  filteredData: null,
};
export const timeSheetSlice = createSlice({
  name: 'timeSheet',
  initialState,
  reducers: {
    setAllTimeSheet: (state, action) => {
      state.allTimeSheet = action.payload.data;
    },
    setFilteredData: (state, action) => {
      state.filteredData = action.payload.data;
    },
    setAllMentors: (state, action) => {
      state.allMentors = action.payload;
    },
    setTimeSheet: (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllTimeSheetBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllTimeSheet, setTimeSheet, setAllTimeSheetBySearch, setAllMentors, setFilteredData, reset } = timeSheetSlice.actions;
export const allTimeSheetDetails = (state: RootState) => state.timeSheet.allTimeSheet;
export const filteredTimeSheet = (state: RootState) => state.timeSheet.filteredData;
export const allMentorsDetails = (state: RootState) => state.timeSheet.allMentors;
export const getAllTimeSheetDetails = (state: RootState) => state.timeSheet.data;
export const getTimeSheetTotalRecords = (state: RootState) => state.timeSheet.totalRecords;
export const getAllTimeSheetBySearch = (state: RootState) => state.timeSheet.data;
export default timeSheetSlice.reducer;